const t = (key) => {
  const translations = window.translations || {}
  return translations[key] || key
}

export default t
